import type { VesselCallStatusContextType } from "@features/vessel-call/vessel-call-status/VesselCallStatus";
import { useOutletContext, useParams, useSearchParams } from "react-router-dom";

export const useVesselCallOperationContext = () => {
  const { id } = useParams<{ id: string }>();
  const ctx = useOutletContext<VesselCallStatusContextType | undefined>();
  const [searchParams] = useSearchParams();
  const imo =
    ctx?.vesselRegisterDetailsFixed?.vesselImoNumber ??
    ctx?.vesselCallDetails?.generalDeclaration?.imoNumber;
  const vesselCallId = id ?? searchParams.get("vesselCallId") ?? undefined;
  const queryImo = searchParams.get("vesselImo") ?? undefined;
  return {
    vesselCallId,
    vesselImo: imo === undefined || imo === null ? queryImo : String(imo),
  };
};
